angular.module('homebot.directives')

.directive('refiPoint', ['Dictionary', function(Dictionary){
  return {
    restrict: 'AE',
    controllerAs: 'refiPointCtrl',
    bindToController: {
      loans: '=',
      rateType: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/partials/refi-point.html',

    controller: function(){
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function(prop,args,home){
        var home = {loans: ctrl.loans};
        args = args || {};
        args.rateType = ctrl.rateType;
        return dictionary[prop](home,args);
      };

      ctrl.update = function(){
        ctrl.savingsTotal = ctrl.lookup('refiSavingsTotal');
        ctrl.paymentSavings = ctrl.lookup('refiPaymentSavingsMonthly');
      };
    },

    link: function($scope, el, attrs, ctrl){
      $scope.$watchCollection('refiPointCtrl.loans', ctrl.update);
    }
  }
}]);
